import { render, staticRenderFns } from "./ConcernedContact.vue?vue&type=template&id=a8ba703e"
import script from "./ConcernedContact.vue?vue&type=script&lang=js"
export * from "./ConcernedContact.vue?vue&type=script&lang=js"
import style0 from "./ConcernedContact.vue?vue&type=style&index=0&id=a8ba703e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports